// extracted by mini-css-extract-plugin
export default {"p":"_6f23402910 cff1b25562 _8c2a8566a5","clr":"_049908449d","dls":"_02690ad105"};